<template>
  <div class="nuttrema-list-item-custom" v-if="group.items.length > 0">
    <div class="nuttrema-list-item__group">
      <span>{{ group.title }}</span>
    </div>
    <div class="nuttrema-list-item__table">
      <nuttrema-table>
        <template slot="header">
          <nuttrema-table-column :style-props="columns.name.style" :label="columns.name.label" theme="header" ></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.date.style" :label="columns.date.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.type.style" :label="columns.type.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.status.style" :label="columns.status.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.operations.style" theme="header"></nuttrema-table-column>
        </template>
        <template slot="body">
          <div class="nuttrema-table__body__row" v-for="item in group.items" :id="`nuttrema-table-row-${item.id}`">

            <nuttrema-table-column :style-props="columns.name.style">
              <div class="two-line-text is-link" @click="gotoDetailsPage(item.id)" :title="$t('label.view_detail')">
                <div class="two-line-text__title">
                  <span>{{ item.name }}</span>
                </div>
                <div class="two-line-text__description">
                  <span>{{ item.email }}</span>
                </div>
              </div>
            </nuttrema-table-column>


            <nuttrema-table-column :label="columns.date.label" :style="columns.date.style">
              <div class="two-line-text">
                <div class="two-line-text__title">
                  <span>{{ item.created_at | moment('l') }}</span>
                </div>
                <div class="two-line-text__description">
                  <span>{{ $t('label.expire') }}: {{ item.expiration | moment('from') }}</span>
                </div>
              </div>
            </nuttrema-table-column>

            <nuttrema-table-column :label="columns.type.label" :style="columns.type.style">
              <span>{{ $t(`label.${item.invitation_type}`) }}</span>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.status.style">
              <nuttrema-status-tag
                 related="invitation"
                :available="['unsent', 'sent', 'seen', 'accepted', 'canceled', 'archive']"
                :status="item.status">
              </nuttrema-status-tag>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.operations.style">
              <router-link
                 class="el-button el-button--text"
                :to="{ name: 'invite-details', params: { id: item.id }, query: { returnTo } }">
                {{ $t('label.view_detail') }} <i class="el-icon-arrow-right" aria-hidden="true"></i>
              </router-link>
            </nuttrema-table-column>

          </div>
        </template>
      </nuttrema-table>
    </div>
  </div>
</template>

<script>
import NuttremaIndexListItem from 'components/ui/list/nuttrema-index-list-item';

import NuttremaStatusTag from 'components/ui/label/nuttrema-status-tag';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'participants-index-list-item',
  mixins: [NuttremaIndexListItem],
  components: {
    NuttremaStatusTag,
    NuttremaIconicaSidebarLink,
  },
  data() {
    return {
      columns: {
        name: {
          label: 'label.name',
          style: {
            // width: '300px',
            // 'max-width': '300px',
            'min-width': '200px',
            'flex-basis': 'auto',
            'flex-grow': '1',
            'margin-left': '0.85em',
          },
        },
        date: {
          label: 'label.invited_at',
          style: {
            width: '150px',
            'max-width': '150px',
            'min-width': '100px',
            'flex-basis': 'auto',
            'flex-grow': '0',
          },
        },
        expire: {
          label: 'label.expire',
          style: {
            'max-width': '150px',
            'min-width': '100px',
            'flex-basis': 'auto',
            'flex-grow': '0',
          },
        },
        type: {
          label: 'label.invitation_type',
          style: {
            'min-width': '200px',
            'flex-basis': 'auto',
            'flex-grow': '0',
          },
        },
        status: {
          label: 'label.status',
          style: {
            'max-width': '150px',
            'min-width': '150px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        operations: {
          label: null,
          style: {
            'min-width': '100px',
            'justify-content': 'flex-end',
          },
        },
      },
    };
  },
  methods: {
    picture(item) {
      return item.ProfilePicture ? `${process.env.IMAGES_ROOT}${item.ProfilePicture.path}${item.ProfilePicture.thumbnails.large.filename}` : null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/invitations/list/cmpt-invitations-index-list-item.vue